import React, { useEffect, useRef } from "react";
import ReactDOMServer from "react-dom/server";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import demoAvatar from "src/assets/images/avatars/avatar.png";
import { CAvatar, CCard, CCardBody, CCol, CRow } from "@coreui/react";
import CustomPopup from "src/components/GPSLocation/CustomPopup";
import moment from "moment";

const Mapbox = (props) => {
  const mapContainerRef = useRef(null);
  const latitude = 23.4241;
  const longitude = 53.8478;

  const locations = props.data;

  useEffect(() => {
    mapboxgl.accessToken =
      "pk.eyJ1Ijoid3NpdC1zYW1pdWwiLCJhIjoiY2xqM3g1b3FoMWtpODNyb2RmM2V1aTJzbCJ9.u870I5zQLy6w3dWBby5siw";

    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: "mapbox://styles/wsit-samiul/clj3xauf9008501micfqm31y8",
      center: [longitude, latitude], // Set the initial map center coordinates
      zoom: 6, // Set the initial map zoom level
      scrollZoom: false,
    });

    locations.forEach((location) => {
      if (!location.deviceStatus?.currentPosition) return;
      const { latitude, longitude, updateTimestamp } =
        location.deviceStatus.currentPosition;

      const formattedTimestamp =
        moment(updateTimestamp).format("DD/MM/YYYY, H:mm");

      const popupData = {
        driver: location.driver,
        currentPosition: location.deviceStatus.currentPosition,
        lastUpdated: formattedTimestamp,
      };

      const popupContent = ReactDOMServer.renderToString(
        <CustomPopup device={popupData} demoAvatar={demoAvatar} />
      );

      new mapboxgl.Marker()
        .setLngLat([longitude, latitude])
        .setPopup(new mapboxgl.Popup().setHTML(popupContent))
        .addTo(map);
    });

    // Add zoom controls
    map.addControl(new mapboxgl.NavigationControl(), "top-right");

    return () => map.remove();
  }, [props]);

  return (
    <div>
      <h3 className="mb-1">Vehicle Monitor</h3>
      <div ref={mapContainerRef} style={{ width: "100%", height: "800px" }} />
    </div>
  );
};

export default Mapbox;
